export const version = "abi/5.0.0-beta.153";



//////////////////
// WEBPACK FOOTER
// ./node_modules/@ethersproject/abi/lib.esm/_version.js
// module id = Jn1T
// module chunks = 4